<template>
  <div class="page">
    <header>
      <div class="classlogo"></div>
    </header>
    <span class="updown" @scroll="upDown" v-if="showstyle"></span>
    <div class="cantainer">
      <div class="bannerimg">
        <div class="bannerContent">
          <div class="title">未来课堂-5G+XR教学云平台</div>
          <div class="desc">
            VR未来课堂将虚拟现实技术与实际教育教学知识点紧密结合，覆盖中小学多个学科内容，以多种形式灵活应用于课堂教学、科技馆等不同场景，以优势VR教学资源为核心，打造与实际教育教学高度结合的高仿真、沉浸式、可交互的一体化课堂
          </div>
          <button @click="loginup()">立即登录</button>
        </div>
      </div>
      <!-- 视频 -- 未来课堂-数据赋能教学 -->
      <div class="video">
        <h3>未来课堂-数据赋能教学</h3>
        <div class="cartoon" :class="[playAnimation ? 'playAnimation' : '']" v-if="!videoPlay">
          <span id="text"></span>
          <span id="img"></span>
        </div>
        <video
          src="https://growlib-gw.oss-cn-beijing.aliyuncs.com/video/content/future-classroom.mp4"
          controls
          ref="videoTop"
        ></video>
      </div>
      <div class="resource">
        <div>
          <div class="tit">
            <span class="leftimg"></span>
            <h1>丰富的教学资源</h1>
            <span class="rightimg"></span>
          </div>
          <div class="text">
            <p>
              拥有<span>10000</span>+XR教学资源，覆盖小、初、高各年级，涵盖科学、物理、化学、生物、安全教育等学科，提供全新的探究体验方式，
            </p>
            <br />
            <p>
              随时随地畅游虚拟世界，高度参与互动，实验在身临其境的探索体验中完成素质提升
            </p>
          </div>
          <div class="resourceimg"></div>
        </div>
      </div>
      <!-- 未来课堂-提供沉浸式的互动教学 -->
      <div class="kindsway">
        <div class="tit">
          <span class="leftimg"></span>
          <h1>未来课堂-沉浸式的互动教学</h1>
          <span class="rightimg"></span>
        </div>
        <div class="article">
          <div class="left">
            <div class="tagleft" v-for="item of information" :key="item.title">
              <img :src="item.img" alt="" />
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
          <div class="right">
            <img src="./assets/icon_hudongjiaoxue.png" alt="" />
            <h3>实时互动教学</h3>
            <p>
              实时反馈实验中学生操作数据、学习进度至管理平台，教师快速掌握学生常见问题，及时进行知识点解答
            </p>
          </div>
        </div>
      </div>
      <!-- 综合数据统计 -->
      <div class="echarts">
        <div class="tit">
          <span class="leftimg"></span>
          <h1>班级学生报告</h1>
          <span class="rightimg"></span>
        </div>
        <div class="carousel">
          <div class="content">
            <div class="list">
              <div class="title">
                根据班级学生可输出不同类型报告，从不同维度展现班级学情和学生成绩情况，为教学效果评估提供有效支撑
              </div>
              <div class="last">
                <div ref="main3" class="left"></div>
                <div class="right">
                  <div class="list long">
                    <span>学校名称：</span>
                    <span>北京市一六二中学</span>
                  </div>
                  <div class="list">
                    <span>班级：</span>
                    <span>初一（3）班</span>
                  </div>
                  <div class="list">
                    <span>学生人数：</span>
                    <span>32人</span>
                  </div>
                  <div class="list long">
                    <span>实验名称：</span>
                    <span>探究通电螺线管外部的磁场分布</span>
                  </div>
                  <div class="list">
                    <span>学科：</span>
                    <span>物理</span>
                  </div>
                  <div class="list">
                    <span>实验次数：</span>
                    <span>5次</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/component/footer';
import * as echarts from 'echarts';

export default {
  components: {
    Footer
  },
  data() {
    return {
      information: [
        {
          title: '多种教学模式',
          img: require('./assets/icon_jiaoxuemoshi.png'),
          desc:
            '支持指导、考核、自主等多种教 学模式，满足不同阶段的教学与自学需求'
        },
        {
          title: '课件自由组合',
          img: require('./assets/icon_ziyouzuhe.png'),
          desc:
            '老师备课时可将课件资源任意组合成课程，也可添加课程相关的自有资源'
        },
        {
          title: '教学数据分析',
          img: require('./assets/icon_shujvfenxi.png'),
          desc:
            '支持指导、考核、自主等多种教学模式，满足不同阶段的教学与自学需求'
        },
        {
          title: '教学测评系统',
          img: require('./assets/icon_cepingxitong.png'),
          desc:
            '在虚拟课堂中可对学生进行教授、考核、测评，让学生巩固知识点，并根据学生答题情况自动评分'
        }
      ],
      formlist: [
        {
          desc: '1',
          data: require('./assets/icon_jiaoxuemoshi.png')
        },
        {
          desc: '2',
          data: require('./assets/icon_shujvfenxi.png')
        },
        {
          desc: '3',
          data: require('./assets/icon_cepingxitong.png')
        }
      ],
      showstyle: true,
      oldhandlesize: 0,
      time: null,
      playLock: false,
      playAnimation: false,
      videoPlay: false,
      experimentIndex: 0,
      experimentArr: [
        ['5.43', '29.51', '29.5', '35.54'],
        ['15.15', '30.89', '25.68', '28.28'],
        ['27.67', '25.31', '23.24', '23.78'],
        ['30.45', '30.51', '23.5', '15.54'],
        ['60.15', '20.89', '13.68', '5.28']
      ]
    };
  },
  methods: {
    loginup() {
      window.open('http://t.growlib.com');
    },
    upDown() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 120) {
        this.showstyle = false;
      } else {
        this.showstyle = true;
      }
      if (scrollTop > 320) {
        this.videoAnimation()
      }
    },
    async videoAnimation() {
      if (this.playLock === false) {
        this.playLock = true;
        await new Promise((resolve, reject) => {
          setTimeout(() => { resolve() }, 1000);
        })
        this.playAnimation = true;
        await new Promise((resolve, reject) => {
          setTimeout(() => { resolve() }, 2000);
        })
        let video = this.$refs.videoTop;
        this.videoPlay = true
        video.play();
      }
    },
    initEcharts3() {
      var chartDom = this.$refs.main3;
      var myChart = echarts.init(chartDom);
      var option;
      let seriesData = [
        { value: this.experimentArr[this.experimentIndex][0], name: 'A' },
        { value: this.experimentArr[this.experimentIndex][1], name: 'B' },
        { value: this.experimentArr[this.experimentIndex][2], name: 'C' },
        { value: this.experimentArr[this.experimentIndex][3], name: 'D' }
      ];
      option = {
        title: {
          text: '第' + (this.experimentIndex + 1) + '次实验',
          left: 'center'
        },
        legend: {
          top: 'bottom'
        },
        // color: ['#35a994', '#ca4343', '#11a114', '#11a114'],
        series: [
          {
            name: '面积模式',
            type: 'pie',
            radius: [50, 80],
            center: ['50%', '50%'],
            roseType: 'radius',
            label: {
              formatter: '{b}({d}%)'
            },
            itemStyle: {
              borderRadius: 8
            },
            avoidLabelOverlap: false,
            data: seriesData
          }
        ]
      };

      option && myChart.setOption(option);
      setInterval(() => {
        this.experimentIndex === 4
          ? (this.experimentIndex = 0)
          : (this.experimentIndex = this.experimentIndex + 1);
        option.title.text = '第' + (this.experimentIndex + 1) + '次实验';
        option.series[0].data = [
          { value: this.experimentArr[this.experimentIndex][0], name: 'A' },
          { value: this.experimentArr[this.experimentIndex][1], name: 'B' },
          { value: this.experimentArr[this.experimentIndex][2], name: 'C' },
          { value: this.experimentArr[this.experimentIndex][3], name: 'D' }
        ];
        myChart.setOption(option);
      }, 1000);
    },
    randomNumber(dataLength = 6) {
      function randomNumberEvery() {
        return Math.random() * 100 + 20;
      }
      let data = [];
      for (let index = 0; index < dataLength; index++) {
        data.push(randomNumberEvery());
      }
      return data;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.upDown);
    this.initEcharts3();
    let timer = setInterval(() => {
      if (document.getElementById('newBridge') != null) {
        document.getElementById('newBridge').style.display = 'none';
        clearInterval(timer);
      }
    }, 100);
  }
};
</script>

<style lang="less" scoped>
.page {
  margin: 0;
  padding: 0;
  position: relative;
  .updown {
    width: 40px;
    height: 40px;
    background: url(./assets/icon_xiala.png);
    background-size: cover;
    position: absolute;
    top: 900px;
    left: 50%;
    z-index: 3;
    display: block;
    animation-name: jump;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  header {
    width: 1200px;
    padding: 20px 0;
    margin: 0 auto;
  }
  .classlogo {
    width: 364px;
    height: 43px;
    background: url(./assets/logo_toubu.png);
    background-size: cover;
  }
  .cantainer {
    width: 100%;
    margin: 0 auto;
    .bannerimg {
      width: 100%;
      height: 804px;
      background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/1.png);
      background-size: cover;
      position: relative;
      .bannerContent {
        width: 1200px;
        margin: 0 auto;
        .title {
          font-size: 40px;
          font-weight: bold;
          color: #292f5d;
          line-height: 62px;
          letter-spacing: 1px;
          padding-top: 194px;
        }
        .desc {
          width: 565px;
          font-size: 18px;
          font-weight: 400;
          color: #292f5d;
          line-height: 36px;
          letter-spacing: 1px;
          margin-top: 36px;
        }
        > button {
          width: 300px;
          height: 60px;
          border: none;
          color: #fff;
          font-size: 20px;
          // font-weight:bold;
          border-radius: 20px;
          letter-spacing: 4px;
          background: linear-gradient(to right, #f27c2c, #ffd214);
          margin-top: 50px;
          cursor: pointer;
        }
      }
    }
    .video {
      width: 1200px;
      padding: 70px 0;
      margin-top: -110px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.6);
      z-index: 1;
      position: relative;
      overflow: hidden;
      > h3 {
        height: 68px;
        background: #3d3e4a;
        color: #fff;
        font-size: 24px;
        font-weight: 550;
        line-height: 68px;
        padding-left: 100px;
      }
      .cartoon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.9);
        bottom: 70px;
        left: 0;
        position: absolute;
        opacity: 1;
        width: 100%;
        height: 676px;
        transition: all 2s;
        // display: block;
        #img {
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/5.png);
          width: 250px;
          height: 19px;
          display: inline-block;
          background-size: cover;
          z-index: 5;
          transition: all 2s;
          bottom: 0;
        }
        #text {
          width: 250px;
          height: 42px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/4.png);
          background-size: cover;
          bottom: -100px;
          transition: all 2s;
        }
      }
      .playAnimation {
        opacity: 0;
        #img {
          position: relative;
          bottom: -600px;
        }
        #text {
          position: relative;
          bottom: 600px;
        }
      }

      > video {
        width: 100%;
        height: 676px;
        display: block;
      }
    }
    // .video:hover{
    //     .img{
    //         animation:myfirst 3s;
    //         display: block;
    //     }
    //     .text{
    //         animation:myfirst 3s;
    //         bottom: -100px;
    //         display: block;
    //     }
    //     @keyframes myfirst{
    //         0%   {bottom: -100px;}
    //         100% {bottom: 0px;}
    //     }
    // }
    .resource {
      height: 940px;
      background: #f8fbff;
      padding: 50px 0;
      width: 100%;
      margin: 0 auto;
      position: relative;
      > div {
        width: 1200px;
        margin: 0 auto;
      }
      .tit {
        display: flex;
        justify-content: center;
        align-items: center;
        .leftimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/3.png);
          background-size: cover;
        }
        .rightimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/2.png);
          background-size: cover;
        }
        > h1 {
          font-size: 34px;
          text-align: center;
          font-weight: bold;
          color: #4e5471;
          margin-left: 30px;
          margin-right: 30px;
        }
      }
      .text {
        width: 1035px;
        height: 72px;
        font-size: 17.5px;
        margin: 30px auto;
        color: #787c8d;
        > p {
          width: 100%;
        }
        > span {
          font-size: 18.5px;
        }
      }
      .resourceimg {
        height: 500px;
        width: 100%;
        background: url(./assets/bj_jiaoxueziyuan.png);
        background-size: cover;
        margin-top: 80px;
      }
    }
    .kindsway {
      height: 810px;
      background: #fff;
      // opacity: 0.5;
      padding: 20px 0;
      margin: 14px auto;
      width: 1250px;
      padding-bottom: 100px;
      height: 870px;
      .tit {
        display: flex;
        justify-content: center;
        align-items: center;
        .leftimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/3.png);
          background-size: cover;
        }
        .rightimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/2.png);
          background-size: cover;
        }
        > h1 {
          font-size: 34px;
          text-align: center;
          font-weight: bold;
          color: #4e5471;
          margin-left: 30px;
          margin-right: 30px;
        }
      }
      .article {
        padding: 0;
        clear: both;
        margin-top: 40px;
        h3 {
          text-align: center;
          font-size: 18px;
          color: #444a62;
          font-weight: bold;
          margin-top: 16px;
        }
        .left {
          width: 890px;
          height: 680px;
          float: left;

          .tagleft {
            width: 420px;
            height: 335px;
            float: left;
            margin-bottom: 10px;
            margin-right: 17px;
            background: #fff;
            padding-top: 40px;
            overflow: hidden;
            box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.15);
            > img {
              width: 290px;
              height: 203px;
              margin-left: 70px;
              transition: all 1s;
            }
            > p {
              opacity: 0;
              transition: all 1s;
              width: 270px;
              letter-spacing: 1px;
              line-height: 22px;
              font-size: 16px;
              color: #444a62;
              margin: 12px 90px;
              display: block;
            }
          }
          .tagleft:hover {
            > img {
              width: 220px;
              height: 134px;
              margin-left: 100px;
            }
            > p {
              opacity: 1;
            }
          }
        }
        .right {
          width: 350px;
          height: 680px;
          // padding: 205px 25px;
          padding: 200px 25px;
          float: left;
          box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.15);
          > img {
            width: 301px;
            height: 203px;
            transition: all 1s;
            margin: 0 auto;
            display: block;
          }
          > p {
            opacity: 0;
            transition: all 1s;
            width: 270px;
            letter-spacing: 1px;
            line-height: 22px;
            font-size: 16px;
            color: #444a62;
            display: block;
            margin: 12px 25px;
          }
        }
        .right:hover {
          > img {
            width: 200px;
            height: 133px;
          }
          > p {
            opacity: 1;
          }
        }
      }
    }
    .echarts {
      background: #f8fbff;
      margin-top: 35px;
      padding-bottom: 0px;
      .tit {
        display: flex;
        justify-content: center;
        align-items: center;
        .leftimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/3.png);
          background-size: cover;
        }
        .rightimg {
          width: 116px;
          height: 14px;
          display: inline-block;
          background: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/future/2.png);
          background-size: cover;
        }
        > h1 {
          font-size: 34px;
          text-align: center;
          font-weight: bold;
          color: #4e5471;
          margin: 30px 30px 30px 30px;
          // margin-left: 30px;
          // margin-right: 30px;
        }
      }
      .showdata {
        height: 450px;
        background: linear-gradient(
          to top,
          rgba(63, 146, 255, 0.1) 0%,
          rgba(63, 146, 255, 0) 100%
        );
        p {
          text-align: center;
          font-size: 18px;
          color: #787c8d;
          margin-bottom: 19px;
        }
        .formdata {
          width: 100%;
          height: 325px;
          margin-bottom: 57px;
          display: flex;
          justify-content: center;
          // >img{

          // }
          // overflow: hidden;
        }
        .cortal {
          width: 100%;
          display: flex;
          justify-content: center;
          height: 60px;
          > span {
            width: 45px;
            height: 4px;
            display: inline-block;
            background: #f27529;
            border-radius: 2px;
            z-index: 5;
          }
        }
      }
    }
  }
}
.carousel {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  .content {
    width: 100%;
    .title {
      font-size: 18px;
      //   font-weight: 600;
      color: #787c8d;
      line-height: 37px;
      text-align: center;
      margin-top: 0px;
    }
    .coverEcharts {
      width: 1200px;
      height: 325px;
      margin-top: 19px;
    }
    .last {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 19px;
      .left {
        width: 600px;
        height: 425px;
      }
      .right {
        width: 44%;
        margin-top: 120px;
        .list {
          width: 260px;
          height: 60px;
          float: left;
          span {
            font-size: 21px;
            font-weight: 400;
            color: #6d819c;
            line-height: 30px;
            letter-spacing: 1px;
          }
          span:nth-child(2n) {
            color: #000000;
          }
        }
        .long {
          width: 100%;
        }
      }
    }
  }
  .cut {
    margin: 0 auto;
    display: flex;
    margin-top: 58px;
    width: fit-content;
    > div {
      width: 22px;
      height: 4px;
      background: #4e5471;
      border-radius: 4px;
      opacity: 0.3;
      margin: 0 9px;
      cursor: pointer;
    }
    .active {
      width: 45px;
      background: #f27529;
      opacity: 1;
    }
  }
}
/* 动画代码 */
@keyframes jump {
  from {
    top: 900px;
  }
  to {
    top: 904px;
  }
}
</style>
